// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1exAA","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2htLP"};